import React from 'react'

import { useCurrentShop } from '@modules/Dashboard/hooks/useCurrentShop'
import { routing } from '@utils/routing'

import type { ConfirmBarViewProps } from './ConfirmBarView'
import { ConfirmBarView } from './ConfirmBarView'

type ConfirmBarContainerProps = Omit<ConfirmBarViewProps, 'dashboardLogo'>

export const ConfirmBarContainer = (props: ConfirmBarContainerProps) => {
  const { currentShop } = useCurrentShop({ staleTime: Infinity })

  return (
    <ConfirmBarView
      dashboardLogo={{ name: currentShop?.name, to: routing.home.toString() }}
      {...props}
    />
  )
}
